
define('text!modules/reporting/campaigns/technology/templates/technology.html',[],function () { return '<div class="w-panel-body w-technology-panel"></div>\n';});

